import React, { FC, useCallback } from 'react';

import { Box } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { useGeolocation } from 'state/geolocation';
import { GeolocationPermissionStates } from 'utils/geolocation';

const ContentContainer = styled.div<{ isListView?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GeoLocationAsk: FC<{ isListView?: boolean }> = ({ isListView = false }) => {
  const { formatMessage } = useIntl();

  const { setPermission, loadCurrentPosition } = useGeolocation();
  const handleGeolocationPrompt = useCallback(() => {
    setPermission(GeolocationPermissionStates.GRANTED);
    loadCurrentPosition();
  }, [loadCurrentPosition, setPermission]);

  return (
    <ContentContainer isListView={isListView}>
      <Box margin="0 0 0.625rem">
        <ActionButton data-testid="no-stores-geolocation-allow" onClick={handleGeolocationPrompt}>
          {formatMessage(messages.shareYourLocation)}
        </ActionButton>
      </Box>
    </ContentContainer>
  );
};
const messages = defineMessages({
  shareYourLocation: {
    id: 'shareYourLocation',
    defaultMessage: 'Share your location',
    description: 'No description',
  },
});
